// eslint-disable-next-line import/prefer-default-export
export const PLACEHOLDER_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/spenza-recipe-app.appspot.com/o/placeholders%2Ficon.png?alt=media&token=5fb6307c-3844-4486-b273-7a53d19b66cc';

/** Format a quantity to at most 2 decimal places, dropping trailing zeros. */
export function fmtQty(raw) {
    const n = parseFloat(raw);
    if (!Number.isFinite(n)) return raw ?? '';
    const s = n.toFixed(2).replace(/\.?0+$/, '');
    return s;
}